import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=21600, public'
  }),

  data() {
    return {
      loaded: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),

  mounted() {
    this.loaded = true;
  },

  methods: {
    tracking() {
      try {
        window.mdm_events(3, this, 'track-event', {
          event_category: 'Dev_Durable',
          event_action: 'Clic_infos',
          event_label: 'Eco Mobilier'
        });
      } catch (e) {
        console.warn(e);
      }
    }

  }
};